import { HTTP } from './HTTP.js';

export class PortCallsService {
  readonly organisationId: string;
  readonly baseUrl: string;

  constructor(organisationId: string) {
    this.organisationId = organisationId;
    this.baseUrl = `/api/customer/organisation/${organisationId}/port-calls`;
  }

  index() {
    return HTTP.make(this.baseUrl, 'get');
  }

  totals() {
    return HTTP.make(`${this.baseUrl}/totals`, 'get');
  }

  vessels() {
    return HTTP.make(`${this.baseUrl}/vessels`, 'get');
  }

  schedule(portId: string) {
    const path = `${this.baseUrl}/${portId}/schedule`;
    return HTTP.make(path, 'get');
  }

  voyageOverview(portId: string) {
    const path = `${this.baseUrl}/${portId}/overview`;
    return HTTP.make(path, 'get');
  }

  activities(portId: string) {
    const path = `${this.baseUrl}/${portId}/activity`;
    return HTTP.make(path, 'get');
  }

  tracking(portId: string) {
    const path = `${this.baseUrl}/${portId}/tracking`;
    return HTTP.make(path, 'get');
  }

  selection(portId: string) {
    const path = `${this.baseUrl}/${portId}/selection`;
    return HTTP.make(path, 'get');
  }

  cargoLineUp(portId: string) {
    const path = `${this.baseUrl}/${portId}/cargo-lineup`;

    return {
      index: () => {
        return HTTP.make(path, 'get');
      },
      filters: () => {
        return HTTP.make(`${path}/filters`, 'get');
      },
      widgets: () => {
        return HTTP.make(`${path}/activity`, 'get');
      },
    };
  }

  documents(portId: string) {
    const path = `${this.baseUrl}/${portId}/documents`;

    return {
      index: () => {
        return HTTP.make(path, 'get');
      },
      download: () => {
        return HTTP.make(`${path}/download`, 'get');
      },
    };
  }

  portRotation(portId: string) {
    const path = `${this.baseUrl}/${portId}/schedules`;
    return HTTP.make(path, 'get');
  }
}
